import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    cate = '',
    group = '',
    roles = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.perms.getRolePerms, {
        cate,
        group,
        roles,
    }, options);
    if (error) return { error, status };
    return content || { rows: [] };
};
